import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Hoja } from 'src/app/hojas-call-center/models/Hoja';
import { environment } from 'src/environments/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({providedIn: 'root'})

export class HojaService
{
  private hostPeticion : string = environment.hojaWSBase;

  constructor(private http: HttpClient){}

  guardarHoja(token: string, hoja: Hoja): Promise<{ success: boolean; message: string; hoja?: any }> {
    const url = this.hostPeticion + '/GuardarHoja/GuardarHoja';

    let headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .set('Authorization', 'Bearer ' + token);

    if (!environment.production) {
      headers = headers.set('Access-Control-Allow-Origin', '*');
    }

    return lastValueFrom(
      this.http.post<{ success: boolean; message: string; hoja?: any }>(url, hoja, { headers })
    ).then((response) => {
      if (!response || typeof response.success === 'undefined') {
        // esto sí es raro → lanzo
        throw new Error('Respuesta inesperada del servidor');
      }
      return response;
    });
  }

  siniestroHoja(token:string){
    let url:string = this.hostPeticion +"/AlbaranTall/buscarSiniestroRal";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }

    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,null,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }

  public updateHoja(token: string, array: any){
    let url:string = this.hostPeticion  +"/AlbaranTall/update";

    let options = new HttpHeaders();
    options = options.set("Content-Type", "application/json");
    options = options.set('Accept', 'application/json');
    options = options.set('Access-Control-Allow-Origin', 'https://api.hub.test.ralarsa.com');
    options = options.set('Authorization', 'Bearer ' + token);

    if (!environment.production){
      options = options.set('Access-Control-Allow-Origin', '*');
    }

    const httpOptions = {
      headers: options,

      params: new HttpParams({})
    }


    return new Promise<any>((resolve, reject) =>
    {
      this.http.post(url,array,httpOptions)
        .subscribe
        ({
          next:(response:any)=>resolve(response),
          error:(err)=>{reject(err)}
        });
    });
  }
}
